import { createSelector } from '@reduxjs/toolkit';

import { initialTasksState, tasksAdapter } from './tasksReducer';
import { TASKS_REDUCER_KEY, type TaskCollectionStatus, type TasksRootState, type TasksState } from './tasksTypes';

export const getTasksStore = (state: TasksRootState): TasksState => state[TASKS_REDUCER_KEY] ?? initialTasksState;

const adapterSelectors = tasksAdapter.getSelectors<TasksRootState>(getTasksStore);

export const getAllTasks = adapterSelectors.selectAll;
export const getTaskById = adapterSelectors.selectById;

export const getTasksForSurface = createSelector(
  [getAllTasks, (_state: TasksRootState, surface: string): string => surface],
  (tasks, surface) => tasks.filter((task) => task.surfaces.includes(surface)),
);

export const getTaskCollectionStatus = (state: TasksRootState): TaskCollectionStatus => {
  const store = getTasksStore(state);
  if (store.error !== null) return 'error';
  return store.loadPending ? 'loading' : 'ready';
};

export const getTasksLoadPending = (state: TasksRootState): boolean => getTasksStore(state).loadPending;
export const getTasksReadError = (state: TasksRootState): string | null => getTasksStore(state).error;
export const getTasksWriteError = (state: TasksRootState): string | null => getTasksStore(state).writeError;
